export const BaseURL = process.env.REACT_APP_API_BASE_URL;
export const ContestToken = 'quai3aequie7chah3choofae4Ecaht9aiRooda7uu3goo7iepie3eecohciThaic';

export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};
